import { CSSProperties } from "react";
import { Button } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

export const RemoveButtonInvoice = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  color: ${(props) => props.theme.colors.manatee};
`;

export const DocumentContainer = styled.div`
  display: grid;
  grid-template-columns: 36% 36% 11% 11%;
  align-items: center;
  grid-column-gap: 20px;
`;

export const CheckboxDocument = styled.div`
  margin-bottom: 15px;
  .ant-checkbox-wrapper > .ant-checkbox > .ant-checkbox-inner {
    border-radius: 2px;
  }
`;

export const FormAddInvoices = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  align-items: right;
  margin-top: 0;
  position: relative;

  .ant-checkbox-wrapper > .ant-checkbox > .ant-checkbox-inner {
    border-radius: 2px;
  }
  &.disabled {
    grid-template-columns: 1fr;
  }

  div {
    .ant-form-item-control-input-content {
      position: relative;
      width: 100%;
    }
  }

  input {
    margin: 0 20px;
  }

  .ant-form-item-label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 600;
    padding: 0;
  }

  .ant-form-item-control-input-content {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const InvoicesField: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  margin: 0,
  color: theme["@default-color"],
  fontFamily: theme["@font-family"],
};

export const InvoicesFieldIcon: CSSProperties = {
  marginTop: "10px",
  marginLeft: "0",
};

export const AddButtonInvoice = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  float: left;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.colors.manatee};

  .addButtonInvoices {
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;
